import styled from "styled-components";

const Div = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    padding-top: 120px; /* 👈 important if you have a fixed header */
`;

const Content = styled.div`
    width: min(800px, 90%);
    margin-bottom: 80px;
    line-height: 1.6;
    font-size: 16px;
    color: #222;
`;

const Header = styled.h1`
    margin: 0 0 40px 0;
    font-size: 28px;
`;

function Impressum() {
    return (
        <Div>
            <Content>
            <Header>I M P R E S S U M</Header>
            <b>Angaben gemäß § 5 TMG</b><br/><br/>
frank IMMOBILIEN<br/>
Rothenberg-Nord 5<br/>
82431 Kochel am See<br/>
Fon +49 (0) 8041 793 2120<br/>
Mobil +49 (0) 176 55851133<br/>
Mail: kontakt@frankimmobilien.de<br/>
Web: www.frankimmo.de<br/><br/>

<b>Vertretungsberechtigter:</b> <br/>
Jürgen Frank<br/><br/>

<b>Berufskammer:</b><br/>
IHK für München und Oberbayern Max-Joseph-Str. 2, 80333 München<br/><br/>

<b>Aufsichtsbehörde:</b><br/>
IHK für München und Oberbayern Max-Joseph-Str. 2, 80333 München<br/>
Immobilienmakler gem. § 34c GewO<br/><br/>

<b>Redaktionell Verantwortlich:</b><br/>
Jürgen Frank<br/><br/>



<b>Verbraucherinformationen zur alternativen Streitschlichtung:</b><br/>
(Art 14 (1) ODR-VO und $ 36 VSBG)<br/>
Die Internetplattformen der Europäischen Union zur Online-Streitbeilegung (sog. „OS-Plattform“) für Verbraucher ist unter dem folgendem Link erreichbar: http://ec.europa.eu/consumers/odr<br/>
Wir nehmen nicht an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil.<br/><br/>



            </Content>
        </Div>
    )
}

export default Impressum;